// Module
var code = "<div if=\"!interaction\" class=\"gc-interaction gc-disable\"> </div>";
// Exports
export default code;